import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-toggle',
  templateUrl: './form-toggle.component.html',
  styleUrls: ['./form-toggle.component.sass'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormToggleComponent),
      multi: true
    }
  ]
})
export class FormToggleComponent implements OnInit, ControlValueAccessor {
  @Input() name = 'toggle';
  @Input() value = false;
  @Input() disabled = false;
  @Input() danger = false;
  @Input() success = false;
  @Output() toggleChange = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  propagateChange = (_: any) => {};

  writeValue(value: any) {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  onValueChange(value) {
    this.propagateChange(value);
    this.toggleChange.emit(value);
  }
}
